import { render, staticRenderFns } from "./queryCoPerfReportList.vue?vue&type=template&id=790c60b3"
import script from "./queryCoPerfReportList.vue?vue&type=script&lang=js"
export * from "./queryCoPerfReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports